module.exports = __webpack_public_path__ + "img/logo_bts.76bd4f5c.png";